import { useTribalContext } from '@/context/tribal';
import useGlobalStore, { GlobalStoreStateConfiguration } from '@/stores/globalStore';
import { getActiveConfiguration } from './storeUtils';

export enum BannerType {
  EventRetail = 'eventRetail',
  EventFleet = 'eventFleet',
  ServiceRetail = 'serviceRetail',
  ServiceFleet = 'serviceFleet',
}

export type Banner = {
  show: 'true' | 'false';
  title: string;
  titleBold: string;
  copy: string;
  cta: string;
  href: string;
  emphasis: string;
  image: string;
  imageAlt: string;
  terms: string;
  startDate: number;
  endDate: number;
  modelIds?: string[];
};

export const getBanner = (type: BannerType): Banner | undefined => {
  const { configManager } = useTribalContext();

  return findBanner(configManager.get(`banners.${type}`));
};

export const findBanner = (banners: Banner[]) => {
  const { app } = useGlobalStore();
  const activeConfiguration: GlobalStoreStateConfiguration | undefined =
    getActiveConfiguration(app);
  const modelId = activeConfiguration?.pdbData?.derivative?.modelId;

  const validBanners = banners.filter((banner: Banner) => {
    if (banner.show === 'false') return false;
    if (banner.endDate && banner.endDate <= Date.now()) return false;
    if (banner.startDate && banner.startDate >= Date.now()) return false;
    return true;
  });

  const generalBanner = validBanners.find((banner: Banner) => !banner?.modelIds?.length);

  const modelSpecificBanner = modelId? validBanners.find((banner) => banner?.modelIds?.includes(modelId)) : undefined;   

  return modelSpecificBanner ?? generalBanner;
};
